import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import moment from 'moment'
import VueCurrencyInput from 'vue-currency-input'
import VueTour from 'vue-tour'

import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

Vue.use(
  Vuetify,
  {
    iconfont: 'mdi'
  },
  {
    moment
  }
)

Vue.use(VueCurrencyInput)

Vue.config.productionTip = false

/* eslint-disable no-alert, no-console */

new Vue({
  router,
  store,
  beforeCreate () {
    this.$store.commit('initialiseStore')
  },
  render: h => h(App)
}).$mount('#app')
